<eds-simple-modal
  *ngIf="(isVisible$ | async) === true"
  [config]="modalConfig"
  [modalId]="'subscriptionsProductsModal'"
  [showModal]="true"
  [showClose]="true"
  [disableCloseOnBackground]="true"
  (onClose)="onModalClose()"
>
  <div
    modal-body
    class="products-modal__body"
    *ngIf="(isEmailPreferences$ | async) === false"
  >
    <div>{{ "subscriptions.modal-body-title" | translate }}</div>
    <div class="products-modal__body-text">
      {{ "subscriptions.modal-body-text" | translate }}
    </div>
    <div edsRow>
      <eds-chips
        *ngFor="let docTypeChip of docTypeChips"
        [id]="docTypeChip.id"
        [chips]="docTypeChip.chips"
        [checked]="docTypeChip.selected"
        (click)="changeSelection($event)"
        class="products-modal__body-chips"
      ></eds-chips>
    </div>
  </div>
  <div
    modal-body
    class="products-modal__body-accordion"
    *ngIf="(isEmailPreferences$ | async) === true"
  >
    <eds-accordion>
      <eds-accordion-item
        [accordionItemId]="'shareclass-accordion-filter'"
        [title]="'subscriptions.shareclass-accordion-filter' | translate"
        [expanded]="false"
      >
        <div edsSpacing="lg" class="products-modal__body-accordion-chips">
          <eds-chips
            *ngFor="let shareClass of shareClasses"
            [id]="shareClass.id"
            [chips]="shareClass.chips"
            [checked]="shareClass.selected"
            (click)="changeSelection($event)"
            class="products-modal__body-chips"
          ></eds-chips>
        </div>
      </eds-accordion-item>
      <eds-accordion-item
        [accordionItemId]="'document-type-accordion-filter'"
        [title]="'subscriptions.document-type-accordion-filter' | translate"
        [expanded]="false"
      >
        <div edsSpacing="lg" class="products-modal__body-accordion-chips">
          <eds-chips
            *ngFor="let documentType of mockDocTypes"
            [id]="documentType.id"
            [chips]="documentType.chips"
            [checked]="documentType.selected"
            (click)="changeSelection($event)"
            class="products-modal__body-chips"
          ></eds-chips>
        </div>
      </eds-accordion-item>
    </eds-accordion>
  </div>
  <div modal-footer class="products-modal__footer">
    <button
      id="btnSubsProductClose"
      class="ft__btn"
      edsButton="secondary"
      size="normal"
      (click)="onModalClose()"
      data-analytics-no-event="true"
    >
      <span class="ft__btn__txt">{{
        "subscriptions.close-modal" | translate
      }}</span>
    </button>
    <button
      id="btnSubsProductSave"
      class="ft__btn products-modal__footer-button-right"
      edsButton="primary"
      size="normal"
      [noMargin]="true"
      (click)="updateDocs()"
      data-analytics-no-event="true"
    >
      <span class="ft__btn__txt">{{
        "subscriptions.submit-modal" | translate
      }}</span>
    </button>
  </div>
</eds-simple-modal>
